/**
 * SHIM-модуль для textarea_autosize.js
 */
require('textarea-autosize/dist/jquery.textarea_autosize.js')
